import React, { Component } from 'react';

export default class extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.chart = echarts.init(this.refs.chart);
        

        this.props.setOption().then(option => {
            this.chart.clear();
            setTimeout(() => {
                this.chart.setOption(option);
            }, 20);
        })
    }

    
    componentWillReceiveProps(nextProps) {
        if(nextProps.keywords && this.v !== nextProps.keywords.v) {
            this.v = nextProps.keywords.v;
            this.props.setOption().then(option => {
                this.chart.clear();
                setTimeout(() => {
                    this.chart.setOption(option);
                }, 20);
            });
        }  
    }

    render() {
        return (
            <div className="root-chart" ref="chart"></div> 
        )
    }
}